export const timezoneOffset = new Date().getTimezoneOffset();

export const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
